// extracted by mini-css-extract-plugin
module.exports = {"search":"styles_search__1t0un"};